import { render, staticRenderFns } from "./AddLovSize.vue?vue&type=template&id=79cf94b8"
import script from "./AddLovSize.vue?vue&type=script&lang=js"
export * from "./AddLovSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports